import { FormattedMessage } from 'react-intl';
import { useMemo } from 'react';

import { ContentWrapper } from '../../../../common/content-wrapper';
import { useStyles } from './video.styles';
import { ListUnordered } from '../../../../common';
import { VideoButton } from '../../video-button/video-button';
import blue from '../../../../../assets/images/video/blue.jpg';
import green from '../../../../../assets/images/video/green.jpg';
import grey from '../../../../../assets/images/video/grey.jpg';
import brown from '../../../../../assets/images/video/brown.jpg';
import { PROMO_VIDEO_PAGES } from '../../eyes-promo-video-page/eyes-promo-video-pages';

export const Video = ({ isLoggedIn }: { isLoggedIn?: boolean }): JSX.Element => {
  const classes = useStyles();

  const items = useMemo(() => ([
    {
      id: 'neuro.blue',
      item: (
        <VideoButton
          mobileVideoSrc={PROMO_VIDEO_PAGES.blue.mobileVideoSrc}
          desktopVideoSrc={PROMO_VIDEO_PAGES.blue.desktopVideoSrc}
          label="blue"
          imgSrc={blue}
          rootClasses={classes.listItem}
        />
      ),
    },
    {
      id: 'neuro.green',
      item: (
        <VideoButton
          mobileVideoSrc={PROMO_VIDEO_PAGES.green.mobileVideoSrc}
          desktopVideoSrc={PROMO_VIDEO_PAGES.green.desktopVideoSrc}
          label="green"
          imgSrc={green}
          rootClasses={classes.listItem}
        />
      ),
    },
    {
      id: 'neuro.grey',
      item: (
        <VideoButton
          mobileVideoSrc={PROMO_VIDEO_PAGES.grey.mobileVideoSrc}
          desktopVideoSrc={PROMO_VIDEO_PAGES.grey.desktopVideoSrc}
          label="grey"
          imgSrc={grey}
          rootClasses={classes.listItem}
        />
      ),
    },
    {
      id: 'neuro.brown',
      item: (
        <VideoButton
          mobileVideoSrc={PROMO_VIDEO_PAGES.brown.mobileVideoSrc}
          desktopVideoSrc={PROMO_VIDEO_PAGES.brown.desktopVideoSrc}
          label="brown"
          imgSrc={brown}
          rootClasses={classes.listItem}
        />
      ),
    },
  ]), []);

  return (
    <section className={isLoggedIn ? classes.rootLog : classes.root} aria-labelledby="video-block-title" data-testid="video-block">
      <ContentWrapper>
        <div className={classes.container}>
          <h2 id="video-block-title" className={classes.title} data-testid="video-block-title">
            <FormattedMessage id="neuro.title" />
          </h2>
          <ListUnordered
            items={items}
            testId="video-list"
            listStyles={classes.list}
            itemStyles={classes.listItem}
          />
        </div>
      </ContentWrapper>
    </section>
  );
};
